// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"44717a28","946":"114c40f3"}[chunkId] + ".chunk.js";
};